export const template = [
  {
    id: 0,
    title: "Template",
    thumbnail:
      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-mobile-PD2.jpeg",
    content: {
      root: {
        id: "root",
        type: "Body",
        props: {
          values: {
            width: { type: "%", contentWidth: 100 },
            contentWidth: "100%",
            backgroundColor: "rgba(255, 255, 255, 1)",
            backgroundImage: { url: "" }
          }
        },
        children: ["brmq2", "7gmk9"]
      },
      "2i9vv": {
        type: "ImageView",
        props: {
          values: {
            animation: {
              direction: "fade",
              show: false,
              duration: 1000,
              type: "ease both"
            },
            align: "center",
            width: "100%",
            parent: "Content",
            href: { url: "", target: "", isCollection: false, collection: 0 },
            containerPadding: "0px",
            imageUrl: {
              url:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-HS8.jpeg",
              urlMobile:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-mobile-65G.png",
              desktop: { width: 900, height: 400 },
              mobile: { width: 600, height: 600 }
            },
            action: { url: "", target: "" },
            altText: "Image one",
            type: "ImageView"
          }
        },
        children: [],
        style: {},
        childOf: "Content",
        id: "2i9vv",
        parent: { id: "45u2m", idx: 0 }
      },
      bukbn: {
        type: "TextView",
        props: {
          values: {
            isLink: false,
            parent: "Content",
            href: { url: "", target: "", isCollection: false, collection: 0 },
            text:
              '<h1 class="ql-align-center">Kicks Shoe ﻿Cleaning Wipes</h1><p><br></p>',
            containerPadding: "20px 0px 0px 0px",
            backgroundColor: "rgba(255,255,255,0)",
            type: "TextView",
            lineHeight: "200%",
            letterSpacing: "1px"
          }
        },
        children: [],
        style: {},
        childOf: "Content",
        id: "bukbn",
        parent: { id: "9ud62", idx: 0 }
      },
      "9ud62": {
        id: "9ud62",
        type: "Content",
        props: {
          values: {
            className: "col-xs-12",
            isBackgroundImage: false,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            backgroundImage: { url: "", urlMobile: "" },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            column: 1,
            type: "Content"
          }
        },
        parent: { id: "7gmk9", idx: 0 },
        childOf: "Row",
        children: ["bukbn", "ejsrt", "7l3bi"]
      },
      "7l3bi": {
        type: "TextView",
        props: {
          values: {
            isLink: false,
            parent: "Content",
            href: { url: "", target: "", isCollection: false, collection: 0 },
            text:
              "<p>Dimension:</p><p>Panjang: 115mm, Tinggi: 68mm, Lebar: 42mm</p><p>Type of Products:</p><p>Wet Wipes</p>",
            containerPadding: "20px",
            backgroundColor: "rgba(255,255,255,0)",
            type: "TextView",
            lineHeight: "160%",
            letterSpacing: "1px"
          }
        },
        children: [],
        style: {},
        childOf: "Content",
        id: "7l3bi",
        parent: { id: "9ud62", idx: 2 }
      },
      "7gmk9": {
        id: "7gmk9",
        type: "Row1",
        props: {
          values: {
            isBackgroundImage: false,
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            backgroundImage: { url: "", urlMobile: "" },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            type: "Row"
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  className: "col-xs-12",
                  isBackgroundImage: false,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  backgroundImage: { url: "", urlMobile: "" },
                  padding: "0px",
                  backgroundColor: "rgba(255,255,255,0)",
                  column: 1,
                  type: "Content"
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 1 },
        childOf: "Body",
        children: ["9ud62"]
      },
      "45u2m": {
        type: "Content",
        props: {
          values: {
            className: "col-xs-12",
            alignment: { vertical: "center", horizontal: "center" },
            isBackgroundImage: false,
            width: { type: "%", contentWidth: 100 },
            parent: "Row",
            bgProps: {
              size: "cover",
              position: "center",
              repeat: "no-repeat",
              ratio: 1.2
            },
            backgroundImage: {
              url: "",
              urlMobile: "",
              desktop: { width: 0, height: 0 },
              mobile: { width: 0, height: 0 }
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            column: 1,
            type: "Content",
            backgroundColorParent: "rgba(255,255,255,0)"
          }
        },
        children: ["2i9vv"],
        childOf: "Row",
        id: "45u2m",
        parent: { id: "brmq2", idx: 0 }
      },
      ejsrt: {
        id: "ejsrt",
        type: "TextView",
        props: {
          values: {
            text:
              '<h2 class="ql-align-center">Cara cepat membersihkan sepatu secara efektif, Kicks Pembersih Sepatu yang diformulasikan secara khusus untuk kanvas, vinyl, nilon, pv, karet, dan denim. Simpel dan mudah digunakan, bagi mereka dengan rutinitas intens yang tinggi, praktis dan efektif. Menghapus noda dan tidak lengket di tangan.</h2>',
            type: "TextView",
            parent: "Content",
            lineHeight: "200%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "10px 0px 0px 0px",
            isLink: false,
            href: { url: "", target: "", isCollection: false, collection: 0 }
          }
        },
        style: {},
        parent: { id: "9ud62", idx: 0 },
        childOf: "Content",
        children: []
      },
      brmq2: {
        type: "Row1",
        props: {
          values: {
            isBackgroundImage: false,
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              position: "center",
              repeat: "no-repeat",
              ratio: 1.2
            },
            name: "Row1",
            backgroundImage: { url: "", urlMobile: "" },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            type: "Row"
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  className: "col-xs-12",
                  alignment: { vertical: "center", horizontal: "center" },
                  isBackgroundImage: false,
                  width: { type: "%", contentWidth: 100 },
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    position: "center",
                    repeat: "no-repeat",
                    ratio: 1.2
                  },
                  backgroundImage: {
                    url: "",
                    urlMobile: "",
                    desktop: { width: 0, height: 0 },
                    mobile: { width: 0, height: 0 }
                  },
                  padding: "0px",
                  backgroundColor: "rgba(255,255,255,0)",
                  column: 1,
                  type: "Content",
                  backgroundColorParent: "rgba(255,255,255,0)"
                }
              },
              children: [],
              childOf: "Row"
            }
          ]
        },
        children: ["45u2m"],
        style: {},
        childOf: "Body",
        id: "brmq2",
        parent: { id: "root", idx: 0 }
      }
    }
  },
  {
    id: 1,
    title: "Template1",
    thumbnail:
      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-CWQ.png",
    content: {
      atjg: {
        id: "atjg",
        type: "TextView",
        props: {
          values: {
            text:
              "<p><strong>Abbie Top.</strong></p><p><strong><span class=\"ql-cursor\">﻿</span></strong>I'm a paragraph. Click here to add your own text and edit me. It's easy.</p><p><br></p>",
            type: "TextView",
            parent: "Content",
            lineHeight: "120%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "10px 10px 0px 10px"
          }
        },
        style: {},
        parent: { id: "a8ch4", idx: 0 },
        childOf: "Content",
        children: []
      },
      c9qg: {
        id: "c9qg",
        type: "Row1",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255, 255, 255, 1)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 1,
                  parent: "Row",
                  className: "col-xs-12"
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 1 },
        childOf: "Body",
        children: ["ebk9g"]
      },
      root: {
        id: "root",
        type: "Body",
        props: {
          values: {
            width: { type: "px", contentWidth: 800 },
            contentWidth: "800px",
            backgroundColor: "rgba(248, 248, 248, 1)",
            backgroundImage: { url: "" }
          }
        },
        children: ["bdrb9", "c9qg", "b2boq", "1kfnk", "2csn7", "ell9a"]
      },
      "1kfnk": {
        id: "1kfnk",
        type: "Row2",
        props: {
          values: {
            type: "Row",
            align: "flex-end",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 2,
                  parent: "Row",
                  className: "col-xs-12 col-lg-6 col-md-6"
                }
              },
              childOf: "Row",
              children: []
            },
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 2,
                  parent: "Row",
                  className: "col-xs-12 col-lg-6 col-md-6"
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 2 },
        childOf: "Body",
        children: ["cbop5", "2ounm"]
      },
      "1ul4s": {
        id: "1ul4s",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 2,
            parent: "Row",
            className: "col-xs-12 col-lg-6 col-md-6"
          }
        },
        parent: { id: "b2boq", idx: 0 },
        childOf: "Row",
        children: ["57dn9"]
      },
      "2csn7": {
        id: "2csn7",
        type: "Row2",
        props: {
          values: {
            type: "Row",
            align: "flex-end",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 2,
                  parent: "Row",
                  className: "col-xs-12 col-lg-6 col-md-6"
                }
              },
              childOf: "Row",
              children: []
            },
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 2,
                  parent: "Row",
                  className: "col-xs-12 col-lg-6 col-md-6"
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 3 },
        childOf: "Body",
        children: ["5q9ne", "7ss6o"]
      },
      "2ounm": {
        id: "2ounm",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 2,
            parent: "Row",
            className: "col-xs-12 col-lg-6 col-md-6"
          }
        },
        parent: { id: "1kfnk", idx: 1 },
        childOf: "Row",
        children: ["52v93"]
      },
      "52v93": {
        id: "52v93",
        type: "ImageView",
        props: {
          values: {
            type: "ImageView",
            align: "center",
            width: "100%",
            action: { url: "", target: "" },
            parent: "Content",
            altText: "Image one",
            imageUrl: {
              url:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-8MS.jpeg",
              urlMobile:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-mobile-TOR.jpeg"
            },
            animation: {
              show: true,
              type: "ease both",
              duration: 1500,
              direction: "moveFromRight"
            },
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "2ounm", idx: 0 },
        childOf: "Content",
        children: []
      },
      "57dn9": {
        id: "57dn9",
        type: "ImageView",
        props: {
          values: {
            href: {
              url: "https://ola.id",
              target: "_blank",
              collection: 0,
              isCollection: false
            },
            type: "ImageView",
            align: "center",
            width: "100%",
            action: { url: "", target: "" },
            parent: "Content",
            altText: "Image one",
            imageUrl: {
              url:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-FBP.jpeg",
              urlMobile:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-mobile-11K.jpeg"
            },
            animation: {
              show: true,
              type: "ease both",
              duration: 1500,
              direction: "moveFromLeft"
            },
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "1ul4s", idx: 0 },
        childOf: "Content",
        children: []
      },
      "5i4gu": {
        id: "5i4gu",
        type: "TextView",
        props: {
          values: {
            text:
              '<h1 class="ql-align-center"><strong>A/W Collections</strong></h1><p><br></p>',
            type: "TextView",
            parent: "Content",
            lineHeight: "200%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "40px 20px 20px 20px"
          }
        },
        style: {},
        parent: { id: "ebk9g", idx: 0 },
        childOf: "Content",
        children: []
      },
      "5q9ne": {
        id: "5q9ne",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 2,
            parent: "Row",
            className: "col-xs-12 col-lg-6 col-md-6"
          }
        },
        parent: { id: "2csn7", idx: 0 },
        childOf: "Row",
        children: ["9d4o7"]
      },
      "5t861": {
        id: "5t861",
        type: "FlatButtonView",
        props: {
          values: {
            href: {
              url: "",
              target: "_blank",
              collection: 18,
              isCollection: true
            },
            icon: "",
            text: "View Collection",
            type: "FlatButtonView",
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "flex-start",
            buttonColors: {
              color: "rgba(74, 74, 74, 1)",
              hoverColor: "rgba(66, 214, 150, 0)",
              rippleColor: "#FF9900",
              backgroundColor: "rgba(230, 25, 25, 0)"
            },
            labelPosition: "before",
            containerPadding: "0px 0px 10px 0px"
          }
        },
        style: {},
        parent: { id: "7ss6o", idx: 1 },
        childOf: "Content",
        children: []
      },
      "605p5": {
        id: "605p5",
        type: "FlatButtonView",
        props: {
          values: {
            href: {
              url: "https://ola.id",
              target: "_blank",
              collection: 39,
              isCollection: true
            },
            icon: "",
            text: "Welcome",
            type: "FlatButtonView",
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "center",
            buttonColors: {
              color: "#FFF",
              hoverColor: "#42d696",
              rippleColor: "#FF9900",
              backgroundColor: "#e61919"
            },
            labelPosition: "before",
            containerPadding: "10px"
          }
        },
        style: {},
        parent: { id: "e5m9v", idx: 1 },
        childOf: "Content",
        children: []
      },
      "7ss6o": {
        id: "7ss6o",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 2,
            parent: "Row",
            className: "col-xs-12 col-lg-6 col-md-6"
          }
        },
        parent: { id: "2csn7", idx: 1 },
        childOf: "Row",
        children: ["edlkd", "5t861"]
      },
      "84el9": {
        id: "84el9",
        type: "ImageView",
        props: {
          values: {
            type: "ImageView",
            align: "center",
            width: "100%",
            action: { url: "", target: "" },
            parent: "Content",
            altText: "Image one",
            imageUrl: {
              url:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-5HG.jpeg",
              urlMobile:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-mobile-31U.jpeg"
            },
            animation: {
              show: true,
              type: "ease both",
              duration: 1500,
              direction: "scaleUp"
            },
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "b5mcc", idx: 0 },
        childOf: "Content",
        children: []
      },
      "8npp7": {
        id: "8npp7",
        type: "FlatButtonView",
        props: {
          values: {
            href: {
              url: "",
              target: "_blank",
              collection: 18,
              isCollection: true
            },
            icon: "",
            text: "View Collection",
            type: "FlatButtonView",
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "flex-end",
            buttonColors: {
              color: "rgba(74, 74, 74, 1)",
              hoverColor: "rgba(66, 214, 150, 0)",
              rippleColor: "#FF9900",
              backgroundColor: "rgba(230, 25, 25, 0)"
            },
            labelPosition: "before",
            containerPadding: "0px 0px 10px 10px"
          }
        },
        style: {},
        parent: { id: "cbop5", idx: 1 },
        childOf: "Content",
        children: []
      },
      "988c1": {
        id: "988c1",
        type: "TextView",
        props: {
          values: {
            text:
              '<p class="ql-align-right"><strong>Mia Shirt.</strong></p><p class="ql-align-right">I\'m a paragraph. Click here to add your own text and edit me. It\'s easy.</p>',
            type: "TextView",
            parent: "Content",
            lineHeight: "120%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "10px 10px 0px 0px"
          }
        },
        style: {},
        parent: { id: "cbop5", idx: 0 },
        childOf: "Content",
        children: []
      },
      "9d4o7": {
        id: "9d4o7",
        type: "ImageView",
        props: {
          values: {
            type: "ImageView",
            align: "center",
            width: "100%",
            action: { url: "", target: "" },
            parent: "Content",
            altText: "Image one",
            imageUrl: {
              url:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-RJ1.jpeg",
              urlMobile:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-mobile-8QI.jpeg"
            },
            animation: {
              show: true,
              type: "ease both",
              duration: 1500,
              direction: "scaleUp"
            },
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "5q9ne", idx: 0 },
        childOf: "Content",
        children: []
      },
      "9i7p1": {
        id: "9i7p1",
        type: "FlatButtonView",
        props: {
          values: {
            href: {
              url: "",
              target: "_blank",
              collection: 18,
              isCollection: true
            },
            icon: "",
            text: "View Collection",
            type: "FlatButtonView",
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "flex-start",
            buttonColors: {
              color: "rgba(74, 74, 74, 1)",
              hoverColor: "rgba(66, 214, 150, 0)",
              rippleColor: "#FF9900",
              backgroundColor: "rgba(230, 25, 25, 0)"
            },
            labelPosition: "before",
            containerPadding: "0px 0px 10px 10px"
          }
        },
        style: {},
        parent: { id: "a8ch4", idx: 1 },
        childOf: "Content",
        children: []
      },
      a8ch4: {
        id: "a8ch4",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 2,
            parent: "Row",
            className: "col-xs-12 col-lg-6 col-md-6"
          }
        },
        parent: { id: "b2boq", idx: 1 },
        childOf: "Row",
        children: ["atjg", "9i7p1"]
      },
      b2boq: {
        id: "b2boq",
        type: "Row2",
        props: {
          values: {
            type: "Row",
            align: "flex-end",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 2,
                  parent: "Row",
                  className: "col-xs-12 col-lg-6 col-md-6"
                }
              },
              childOf: "Row",
              children: []
            },
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 2,
                  parent: "Row",
                  className: "col-xs-12 col-lg-6 col-md-6"
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 1 },
        childOf: "Body",
        children: ["1ul4s", "a8ch4"]
      },
      b5mcc: {
        id: "b5mcc",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 2,
            parent: "Row",
            className: "col-xs-12 col-lg-6 col-md-6"
          }
        },
        parent: { id: "ell9a", idx: 1 },
        childOf: "Row",
        children: ["84el9"]
      },
      bdrb9: {
        id: "bdrb9",
        type: "Row1",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: {
              url:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-desktop-QIQ.jpeg",
              urlMobile:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-mobile-AYN.jpeg"
            },
            isBackgroundImage: true
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 1,
                  parent: "Row",
                  className: "col-xs-12"
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 0 },
        childOf: "Body",
        children: ["e5m9v"]
      },
      cbop5: {
        id: "cbop5",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 2,
            parent: "Row",
            className: "col-xs-12 col-lg-6 col-md-6"
          }
        },
        parent: { id: "1kfnk", idx: 0 },
        childOf: "Row",
        children: ["988c1", "8npp7"]
      },
      di42a: {
        id: "di42a",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 2,
            parent: "Row",
            className: "col-xs-12 col-lg-6 col-md-6"
          }
        },
        parent: { id: "ell9a", idx: 0 },
        childOf: "Row",
        children: []
      },
      e5m9v: {
        id: "e5m9v",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 1,
            parent: "Row",
            className: "col-xs-12"
          }
        },
        parent: { id: "bdrb9", idx: 0 },
        childOf: "Row",
        children: ["focfl", "605p5"]
      },
      ebk9g: {
        id: "ebk9g",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 1,
            parent: "Row",
            className: "col-xs-12"
          }
        },
        parent: { id: "c9qg", idx: 0 },
        childOf: "Row",
        children: ["5i4gu"]
      },
      edlkd: {
        id: "edlkd",
        type: "TextView",
        props: {
          values: {
            text:
              "<p><strong>Melisa Coat.</strong></p><p>I'm a paragraph. Click here to add your own text and edit me. It's easy.</p>",
            type: "TextView",
            parent: "Content",
            lineHeight: "120%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "10px 0px 0px 10px"
          }
        },
        style: {},
        parent: { id: "7ss6o", idx: 0 },
        childOf: "Content",
        children: []
      },
      ell9a: {
        id: "ell9a",
        type: "Row2",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 2,
                  parent: "Row",
                  className: "col-xs-12 col-lg-6 col-md-6"
                }
              },
              childOf: "Row",
              children: []
            },
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 2,
                  parent: "Row",
                  className: "col-xs-12 col-lg-6 col-md-6"
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 4 },
        childOf: "Body",
        children: ["di42a", "b5mcc"]
      },
      focfl: {
        id: "focfl",
        type: "TextView",
        props: {
          values: {
            text:
              '<p class="ql-align-justify"><span style="color: rgb(0, 0, 0);">I\'m a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font. I’m a great place for you to tell a story and let your users know a little more about you.</span></p>',
            type: "TextView",
            parent: "Content",
            lineHeight: "120%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "10px"
          }
        },
        style: {},
        parent: { id: "e5m9v", idx: 0 },
        childOf: "Content",
        children: []
      }
    }
  },
  {
    id: 2,
    title: "Template2",
    thumbnail:
      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-AXP.png",
    content: {
      root: {
        id: "root",
        type: "Body",
        props: {
          values: {
            width: { type: "px", contentWidth: 800 },
            contentWidth: "800px",
            backgroundColor: "#ececec",
            backgroundImage: { url: "" }
          }
        },
        children: ["dfjpt", "9n0vq", "9mr2u"]
      },
      "3iekq": {
        id: "3iekq",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 3,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12 col-md-4  col-lg-4",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          }
        },
        parent: { id: "9mr2u", idx: 2 },
        childOf: "Row",
        children: ["bgvac"]
      },
      "5bcmd": {
        id: "5bcmd",
        type: "TextView",
        props: {
          values: {
            text:
              '<h3>MY&nbsp;<span style="color: rgb(211, 179, 184);">CAKES</span>&nbsp;ARE</h3><h3>HANDCRAFTED</h3><h3>WITH LOVE.</h3>',
            type: "TextView",
            parent: "Content",
            lineHeight: "120%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "20px 20px 0px 20px"
          }
        },
        style: {},
        parent: { id: "ctke3", idx: 0 },
        childOf: "Content",
        children: []
      },
      "7iovd": {
        id: "7iovd",
        type: "FlatButtonView",
        props: {
          values: {
            href: {
              url: "",
              target: "_blank",
              collection: 4,
              isCollection: true
            },
            icon: "",
            text: "Meet a Baker",
            type: "FlatButtonView",
            border: { size: 0, type: "solid", color: "#e61919" },
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "center",
            buttonColors: {
              color: "rgba(74, 74, 74, 1)",
              hoverColor: "rgba(66, 214, 150, 0)",
              rippleColor: "#FF9900",
              backgroundColor: "rgba(255, 255, 255, 1)"
            },
            labelPosition: "before",
            containerPadding: "20px 0px 20px 0px"
          }
        },
        style: {},
        parent: { id: "dh085", idx: 0 },
        childOf: "Content",
        children: []
      },
      "8epd5": {
        id: "8epd5",
        type: "TextView",
        props: {
          values: {
            text:
              '<p><span style="color: rgb(64, 54, 55);">I\'m a paragraph. Click here to add your own text and edit me. It’s easy. Just click “Edit Text” or double click me to add your own content and make changes to the font. I’m a great place for you to tell a story and let your users know a little more about you.</span></p>',
            type: "TextView",
            parent: "Content",
            lineHeight: "120%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "0px 20px 20px 20px"
          }
        },
        style: {},
        parent: { id: "ctke3", idx: 3 },
        childOf: "Content",
        children: []
      },
      "9mr2u": {
        id: "9mr2u",
        type: "Row3",
        props: {
          values: {
            type: "Row",
            align: "flex-end",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px 10px 20px 10px",
            backgroundColor: "rgba(255, 255, 255, 1)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 3,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px 10px 0px 10px",
                  className: "col-xs-12 col-md-4  col-lg-4",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: {
                    url:
                      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-desktop-MLL.png",
                    urlMobile:
                      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-mobile-MIP.png"
                  },
                  isBackgroundImage: true
                }
              },
              childOf: "Row",
              children: []
            },
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  width: { type: "%", contentWidth: 100 },
                  column: 3,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  alignment: { vertical: "flex-end", horizontal: "center" },
                  className: "col-xs-12 col-md-4  col-lg-4",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: {
                    url:
                      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-desktop-XJJ.png",
                    urlMobile:
                      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-mobile-D51.png"
                  },
                  isBackgroundImage: true
                }
              },
              childOf: "Row",
              children: []
            },
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 3,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px 10px 0px 10px",
                  className: "col-xs-12 col-md-4  col-lg-4",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: {
                    url:
                      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-desktop-K9Y.png",
                    urlMobile:
                      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-mobile-KYK.png"
                  },
                  isBackgroundImage: true
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 2 },
        childOf: "Body",
        children: ["fkr70", "dh085", "3iekq"]
      },
      "9n0vq": {
        id: "9n0vq",
        type: "Row5",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "10px 10px 20px 10px",
            backgroundColor: "rgba(255, 255, 255, 1)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  width: { type: "%", contentWidth: 100 },
                  column: 3,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px 10px 0px 10px",
                  alignment: { vertical: "center", horizontal: "center" },
                  className: "col-xs-12 col-md-9  col-lg-9",
                  backgroundColor: "rgba(247, 235, 237, 1)",
                  backgroundImage: { url: "", urlMobile: "" },
                  isBackgroundImage: false,
                  backgroundColorParent: "rgba(247, 235, 237, 1)"
                }
              },
              childOf: "Row",
              children: []
            },
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 1,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px 10px 0px 10px",
                  className: "col-xs-12 col-md-3  col-lg-3",
                  backgroundColor: "#FFFFFF",
                  backgroundImage: { url: "", urlMobile: "" },
                  isBackgroundImage: false
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 1 },
        childOf: "Body",
        children: ["ctke3", "emmhl"]
      },
      bgijo: {
        id: "bgijo",
        type: "ImageView",
        props: {
          values: {
            type: "ImageView",
            align: "center",
            width: "100%",
            action: { url: "", target: "" },
            parent: "Content",
            altText: "Image one",
            imageUrl: {
              url:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-VGA.png",
              urlMobile:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-mobile-ZQ9.png"
            },
            animation: {
              show: false,
              type: "ease both",
              duration: 1000,
              direction: "fade"
            },
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "emmhl", idx: 0 },
        childOf: "Content",
        children: []
      },
      bgvac: {
        id: "bgvac",
        type: "FlatButtonView",
        props: {
          values: {
            href: {
              url: "",
              target: "_blank",
              collection: 4,
              isCollection: true
            },
            icon: "",
            text: "Meet a Baker",
            type: "FlatButtonView",
            border: { size: 0, type: "solid", color: "#e61919" },
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "center",
            buttonColors: {
              color: "rgba(74, 74, 74, 1)",
              hoverColor: "rgba(66, 214, 150, 0)",
              rippleColor: "#FF9900",
              backgroundColor: "rgba(255, 255, 255, 1)"
            },
            labelPosition: "before",
            containerPadding: "20px 0px 20px 0px"
          }
        },
        style: {},
        parent: { id: "3iekq", idx: 0 },
        childOf: "Content",
        children: []
      },
      cqvqq: {
        id: "cqvqq",
        type: "FlatButtonView",
        props: {
          values: {
            href: {
              url: "",
              target: "_blank",
              collection: 4,
              isCollection: true
            },
            icon: "",
            text: "Order online",
            type: "FlatButtonView",
            border: { size: 0, type: "solid", color: "#e61919" },
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "center",
            buttonColors: {
              color: "rgba(74, 74, 74, 1)",
              hoverColor: "rgba(66, 214, 150, 0)",
              rippleColor: "#FF9900",
              backgroundColor: "rgba(255, 255, 255, 1)"
            },
            labelPosition: "before",
            containerPadding: "20px 0px 20px 0px"
          }
        },
        style: {},
        parent: { id: "fkr70", idx: 0 },
        childOf: "Content",
        children: []
      },
      ctke3: {
        id: "ctke3",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 3,
            parent: "Row",
            className: "col-xs-12 col-md-9  col-lg-9"
          }
        },
        parent: { id: "9n0vq", idx: 0 },
        childOf: "Row",
        children: ["5bcmd", "8epd5"]
      },
      dfjpt: {
        id: "dfjpt",
        type: "Row1",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.8,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "20px",
            backgroundColor: "rgba(255, 255, 255, 1)",
            backgroundImage: {
              url:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-desktop-IWC.png",
              urlMobile:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-mobile-QA4.png"
            },
            isBackgroundImage: true
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 1,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  className: "col-xs-12",
                  backgroundColor: "rgba(255, 255, 255, 0)",
                  backgroundImage: { url: "", urlMobile: "" },
                  isBackgroundImage: false
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 0 },
        childOf: "Body",
        children: ["ev4ou"]
      },
      dh085: {
        id: "dh085",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 3,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12 col-md-4  col-lg-4",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          }
        },
        parent: { id: "9mr2u", idx: 1 },
        childOf: "Row",
        children: ["7iovd"]
      },
      emmhl: {
        id: "emmhl",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 1,
            parent: "Row",
            className: "col-xs-12 col-md-3  col-lg-3"
          }
        },
        parent: { id: "9n0vq", idx: 1 },
        childOf: "Row",
        children: ["bgijo"]
      },
      ev4ou: {
        id: "ev4ou",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 1,
            parent: "Row",
            className: "col-xs-12"
          }
        },
        parent: { id: "dfjpt", idx: 0 },
        childOf: "Row",
        children: []
      },
      fkr70: {
        id: "fkr70",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 3,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            className: "col-xs-12 col-md-4  col-lg-4",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          }
        },
        parent: { id: "9mr2u", idx: 0 },
        childOf: "Row",
        children: ["cqvqq"]
      }
    }
  },
  {
    id: 3,
    title: "Template3",
    thumbnail:
      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-M12.png",
    content: {
      ffri: {
        id: "ffri",
        type: "Row1",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 1,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  className: "col-xs-12",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: { url: "", urlMobile: "" },
                  isBackgroundImage: false
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 3 },
        childOf: "Body",
        children: ["d95ji"]
      },
      root: {
        id: "root",
        type: "Body",
        props: {
          values: {
            width: { type: "%", contentWidth: 100 },
            contentWidth: "100%",
            backgroundColor: "rgba(255, 255, 255, 1)",
            backgroundImage: { url: "" }
          }
        },
        children: ["dk6vi", "7gmk9", "38bp4", "ffri"]
      },
      "38bp4": {
        id: "38bp4",
        type: "Row1",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 1,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  className: "col-xs-12",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: { url: "", urlMobile: "" },
                  isBackgroundImage: false
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 2 },
        childOf: "Body",
        children: ["3vfes"]
      },
      "3vfes": {
        id: "3vfes",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 1,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          }
        },
        parent: { id: "38bp4", idx: 0 },
        childOf: "Row",
        children: ["61r21"]
      },
      "61r21": {
        id: "61r21",
        type: "ProductListView",
        props: {
          values: {
            list: [39, 25, 16],
            type: "ProductListView",
            parent: "Content",
            showPrice: true,
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "3vfes", idx: 0 },
        childOf: "Content",
        children: []
      },
      "6nkbt": {
        id: "6nkbt",
        type: "TextView",
        props: {
          values: {
            text:
              '<h1 class="ql-align-center"><span style="color: rgb(255, 255, 255);" class="ql-size-large">ALWAYS BE</span></h1><h1 class="ql-align-center"><span style="color: rgb(255, 255, 255);" class="ql-size-large">ORIGINAL</span></h1>',
            type: "TextView",
            parent: "Content",
            lineHeight: "300%",
            letterSpacing: "2px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "dhr0n", idx: 0 },
        childOf: "Content",
        children: []
      },
      "7gmk9": {
        id: "7gmk9",
        type: "Row1",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 1,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  className: "col-xs-12",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: { url: "", urlMobile: "" },
                  isBackgroundImage: false
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 1 },
        childOf: "Body",
        children: ["9ud62"]
      },
      "87dcc": {
        id: "87dcc",
        type: "FlatButtonView",
        props: {
          values: {
            href: { url: "", target: "", collection: 18, isCollection: true },
            icon: "",
            text: "Show All",
            type: "FlatButtonView",
            border: { size: 1, type: "solid", color: "rgba(74, 74, 74, 1)" },
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "center",
            buttonColors: {
              color: "rgba(74, 74, 74, 1)",
              hoverColor: "rgba(155, 155, 155, 0.2)",
              rippleColor: "#FF9900",
              backgroundColor: "rgba(230, 25, 25, 0)"
            },
            labelPosition: "before",
            containerPadding: "20px 10px 20px 10px"
          }
        },
        style: {},
        parent: { id: "d95ji", idx: 0 },
        childOf: "Content",
        children: []
      },
      "9qouq": {
        id: "9qouq",
        type: "FlatButtonView",
        props: {
          values: {
            href: { url: "", target: "", collection: 18, isCollection: true },
            icon: "",
            text: "Shop Now",
            type: "FlatButtonView",
            border: { size: 2, type: "solid", color: "rgba(231, 217, 217, 1)" },
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "center",
            buttonColors: {
              color: "#FFF",
              hoverColor: "rgba(155, 155, 155, 1)",
              rippleColor: "#FF9900",
              backgroundColor: "rgba(230, 25, 25, 0)"
            },
            labelPosition: "before",
            containerPadding: "10px"
          }
        },
        style: {},
        parent: { id: "dhr0n", idx: 2 },
        childOf: "Content",
        children: []
      },
      "9ud62": {
        id: "9ud62",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 1,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          }
        },
        parent: { id: "7gmk9", idx: 0 },
        childOf: "Row",
        children: ["ejsrt"]
      },
      brvmi: {
        id: "brvmi",
        type: "TextView",
        props: {
          values: {
            text:
              '<p class="ql-align-center"><span style="color: rgb(255, 255, 255);">NEW ARRIVALS ARE HERE</span></p>',
            type: "TextView",
            parent: "Content",
            lineHeight: "120%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "10px 0px 0px 0px"
          }
        },
        style: {},
        parent: { id: "dhr0n", idx: 1 },
        childOf: "Content",
        children: []
      },
      d95ji: {
        id: "d95ji",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 1,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          }
        },
        parent: { id: "ffri", idx: 0 },
        childOf: "Row",
        children: ["87dcc"]
      },
      dhr0n: {
        id: "dhr0n",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 1,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          }
        },
        parent: { id: "dk6vi", idx: 0 },
        childOf: "Row",
        children: ["6nkbt", "brvmi", "9qouq"]
      },
      dk6vi: {
        id: "dk6vi",
        type: "Row1",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.7,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: {
              url:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-desktop-T0G.jpeg",
              urlMobile:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-mobile-ZIN.jpeg"
            },
            isBackgroundImage: true
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 1,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  className: "col-xs-12",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: { url: "", urlMobile: "" },
                  isBackgroundImage: false
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 0 },
        childOf: "Body",
        children: ["dhr0n"]
      },
      ejsrt: {
        id: "ejsrt",
        type: "TextView",
        props: {
          values: {
            text:
              '<h2 class="ql-align-center"><span class="ql-size-large">LIMITED EDITION COLLECTION</span></h2>',
            type: "TextView",
            parent: "Content",
            lineHeight: "200%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "10px"
          }
        },
        style: {},
        parent: { id: "9ud62", idx: 0 },
        childOf: "Content",
        children: []
      }
    }
  },
  {
    id: 4,
    title: "Fashion1",
    thumbnail:
      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-13D.png",
    content: {
      root: {
        id: "root",
        type: "Body",
        props: {
          values: {
            width: { type: "%", contentWidth: 100 },
            contentWidth: "100%",
            backgroundColor: "#ececec",
            backgroundImage: { url: "" }
          }
        },
        children: ["fjs4c", "c7kje"]
      },
      t578: {
        id: "t578",
        type: "TextView",
        props: {
          values: {
            text:
              '<h1 class="ql-align-center">Introducing Your New Workout Wardrobe</h1>',
            type: "TextView",
            parent: "Content",
            lineHeight: "200%",
            letterSpacing: "2px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "10px"
          }
        },
        style: {},
        parent: { id: "2b2d0", idx: 0 },
        childOf: "Content",
        children: []
      },
      "2b2d0": {
        id: "2b2d0",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 1,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12 col-md-3  col-lg-3",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          }
        },
        parent: { id: "fjs4c", idx: 0 },
        childOf: "Row",
        children: ["t578", "2h77r"]
      },
      "2h77r": {
        id: "2h77r",
        type: "FlatButtonView",
        props: {
          values: {
            href: { url: "", target: "", collection: 18, isCollection: true },
            icon: "",
            text: "Start Shopping",
            type: "FlatButtonView",
            border: { size: 2, type: "solid", color: "rgba(255, 255, 255, 1)" },
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "center",
            buttonColors: {
              color: "rgba(74, 74, 74, 1)",
              hoverColor: "rgba(66, 214, 150, 0)",
              rippleColor: "rgba(74, 74, 74, 0.4)",
              backgroundColor: "rgba(230, 25, 25, 0)"
            },
            labelPosition: "before",
            containerPadding: "20px 0px 10px 0px"
          }
        },
        style: {},
        parent: { id: "2b2d0", idx: 1 },
        childOf: "Content",
        children: []
      },
      "6rdps": {
        id: "6rdps",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 3,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12 col-md-9  col-lg-9",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          }
        },
        parent: { id: "fjs4c", idx: 1 },
        childOf: "Row",
        children: ["9v61k"]
      },
      "6rnqd": {
        id: "6rnqd",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 3,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            className: "col-xs-12 col-md-4  col-lg-4",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          }
        },
        parent: { id: "c7kje", idx: 0 },
        childOf: "Row",
        children: ["astp6"]
      },
      "9v61k": {
        id: "9v61k",
        type: "ImageView",
        props: {
          values: {
            href: { url: "", target: "", collection: 0, isCollection: false },
            type: "ImageView",
            align: "center",
            width: "100%",
            action: { url: "", target: "" },
            parent: "Content",
            altText: "Image one",
            imageUrl: {
              url:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-N3F.jpeg",
              desktop: { width: 1530, height: 1150 },
              urlMobile: ""
            },
            animation: {
              show: false,
              type: "ease both",
              duration: 1000,
              direction: "fade"
            },
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "6rdps", idx: 0 },
        childOf: "Content",
        children: []
      },
      ahack: {
        id: "ahack",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 3,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12 col-md-4  col-lg-4",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          }
        },
        parent: { id: "c7kje", idx: 2 },
        childOf: "Row",
        children: ["evedf"]
      },
      astp6: {
        id: "astp6",
        type: "TextView",
        props: {
          values: {
            href: {
              url: "https://ola.id",
              target: "_blank",
              collection: 0,
              isCollection: false
            },
            text:
              '<h1 class="ql-align-center"><span style="color: rgb(255, 255, 255);">The Cleo</span></h1><h1 class="ql-align-center"><span style="color: rgb(255, 255, 255);">Story</span></h1>',
            type: "TextView",
            isLink: true,
            parent: "Content",
            lineHeight: "200%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "6rnqd", idx: 0 },
        childOf: "Content",
        children: []
      },
      c7kje: {
        id: "c7kje",
        type: "Row3",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 3,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  className: "col-xs-12 col-md-4  col-lg-4",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: {
                    url:
                      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-desktop-00G.jpeg",
                    mobile: { width: 600, height: 600 },
                    desktop: { width: 300, height: 600 },
                    urlMobile:
                      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-mobile-QIC.jpeg"
                  },
                  isBackgroundImage: true
                }
              },
              childOf: "Row",
              children: []
            },
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 3,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  className: "col-xs-12 col-md-4  col-lg-4",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: {
                    url:
                      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-desktop-266.jpeg",
                    mobile: { width: 600, height: 600 },
                    desktop: { width: 300, height: 600 },
                    urlMobile:
                      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-mobile-9RC.jpeg"
                  },
                  isBackgroundImage: true
                }
              },
              childOf: "Row",
              children: []
            },
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 3,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  className: "col-xs-12 col-md-4  col-lg-4",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: {
                    url:
                      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-desktop-WX4.jpeg",
                    mobile: { width: 600, height: 600 },
                    desktop: { width: 300, height: 600 },
                    urlMobile:
                      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-mobile-Y4H.jpeg"
                  },
                  isBackgroundImage: true
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 1 },
        childOf: "Body",
        children: ["6rnqd", "dh0lh", "ahack"]
      },
      dh0lh: {
        id: "dh0lh",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 3,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12 col-md-4  col-lg-4",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          }
        },
        parent: { id: "c7kje", idx: 1 },
        childOf: "Row",
        children: ["es1qi"]
      },
      es1qi: {
        id: "es1qi",
        type: "TextView",
        props: {
          values: {
            text:
              '<h1 class="ql-align-center"><span style="color: rgb(255, 255, 255);">View Our</span></h1><h1 class="ql-align-center"><span style="color: rgb(255, 255, 255);">Colletion</span></h1>',
            type: "TextView",
            parent: "Content",
            lineHeight: "200%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "dh0lh", idx: 0 },
        childOf: "Content",
        children: []
      },
      evedf: {
        id: "evedf",
        type: "TextView",
        props: {
          values: {
            text:
              '<h1 class="ql-align-center"><span style="color: rgb(255, 255, 255);">Women</span></h1><h1 class="ql-align-center"><span style="color: rgb(255, 255, 255);">Collection</span></h1>',
            type: "TextView",
            parent: "Content",
            lineHeight: "200%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "ahack", idx: 0 },
        childOf: "Content",
        children: []
      },
      fjs4c: {
        id: "fjs4c",
        type: "Row4",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 1,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  className: "col-xs-12 col-md-3  col-lg-3",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: { url: "", urlMobile: "" },
                  isBackgroundImage: false
                }
              },
              childOf: "Row",
              children: []
            },
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 3,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  className: "col-xs-12 col-md-9  col-lg-9",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: { url: "", urlMobile: "" },
                  isBackgroundImage: false
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 0 },
        childOf: "Body",
        children: ["2b2d0", "6rdps"]
      }
    }
  },
  {
    id: 5,
    title: "Fashion2",
    thumbnail:
      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-Z3V.png",
    content: {
      mjqq: {
        id: "mjqq",
        type: "FlatButtonView",
        props: {
          values: {
            href: {
              url: "",
              target: "_blank",
              collection: 25,
              isCollection: true
            },
            icon: "",
            text: "Shop Women",
            type: "FlatButtonView",
            border: { size: 0, type: "solid", color: "#e61919" },
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "center",
            buttonColors: {
              color: "rgba(32, 48, 60, 1)",
              hoverColor: "rgba(155, 155, 155, 0.2)",
              rippleColor: "rgba(255, 153, 0, 0.1)",
              backgroundColor: "rgba(230, 25, 25, 0)"
            },
            labelPosition: "before",
            containerPadding: "20px"
          }
        },
        style: {},
        parent: { id: "1k365", idx: 2 },
        childOf: "Content",
        children: []
      },
      root: {
        id: "root",
        type: "Body",
        props: {
          values: {
            width: { type: "px", contentWidth: 800 },
            contentWidth: "800px",
            backgroundColor: "#ececec",
            backgroundImage: { url: "" }
          }
        },
        children: ["f5n52", "95gb4"]
      },
      "1k365": {
        id: "1k365",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 2,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12 col-lg-6 col-md-6",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: {
              url: "",
              mobile: { width: 0, height: 0 },
              desktop: { width: 0, height: 0 },
              urlMobile: ""
            },
            isBackgroundImage: false
          }
        },
        parent: { id: "f5n52", idx: 1 },
        childOf: "Row",
        children: ["8v4uu", "579tt", "mjqq"]
      },
      "2ac6m": {
        id: "2ac6m",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 2,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12 col-lg-6 col-md-6",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: {
              url: "",
              mobile: { width: 0, height: 0 },
              desktop: { width: 0, height: 0 },
              urlMobile: ""
            },
            isBackgroundImage: false
          }
        },
        parent: { id: "f5n52", idx: 0 },
        childOf: "Row",
        children: ["5hcte"]
      },
      "2d045": {
        id: "2d045",
        type: "DividerView",
        props: {
          values: {
            line: "solid",
            size: "2px",
            type: "DividerView",
            width: "17%",
            parent: "Content",
            lineColor: "rgba(255,255,255,1)",
            alignValue: "center",
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "38lau", idx: 1 },
        childOf: "Content",
        children: []
      },
      "38lau": {
        id: "38lau",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 2,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12 col-lg-6 col-md-6",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: {
              url: "",
              mobile: { width: 0, height: 0 },
              desktop: { width: 0, height: 0 },
              urlMobile: ""
            },
            isBackgroundImage: false
          }
        },
        parent: { id: "95gb4", idx: 0 },
        childOf: "Row",
        children: ["cr1r7", "2d045", "ap843"]
      },
      "5209c": {
        id: "5209c",
        type: "ImageView",
        props: {
          values: {
            href: { url: "", target: "", collection: 0, isCollection: false },
            type: "ImageView",
            align: "center",
            width: "100%",
            action: { url: "", target: "" },
            parent: "Content",
            altText: "Image one",
            imageUrl: {
              url:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-IZ8.jpeg",
              mobile: { width: 0, height: 0 },
              desktop: { width: 883, height: 842 },
              urlMobile: ""
            },
            animation: {
              show: false,
              type: "ease both",
              duration: 1000,
              direction: "fade"
            },
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "bpouu", idx: 0 },
        childOf: "Content",
        children: []
      },
      "579tt": {
        id: "579tt",
        type: "DividerView",
        props: {
          values: {
            line: "solid",
            size: "2px",
            type: "DividerView",
            width: "17%",
            parent: "Content",
            lineColor: "rgba(32, 48, 60, 1)",
            alignValue: "center",
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "1k365", idx: 1 },
        childOf: "Content",
        children: []
      },
      "5hcte": {
        id: "5hcte",
        type: "ImageView",
        props: {
          values: {
            href: { url: "", target: "", collection: 0, isCollection: false },
            type: "ImageView",
            align: "center",
            width: "100%",
            action: { url: "", target: "" },
            parent: "Content",
            altText: "Image one",
            imageUrl: {
              url:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-I2M.jpeg",
              mobile: { width: 0, height: 0 },
              desktop: { width: 871, height: 871 },
              urlMobile: ""
            },
            animation: {
              show: false,
              type: "ease both",
              duration: 1000,
              direction: "fade"
            },
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "2ac6m", idx: 0 },
        childOf: "Content",
        children: []
      },
      "8v4uu": {
        id: "8v4uu",
        type: "TextView",
        props: {
          values: {
            href: { url: "", target: "", collection: 0, isCollection: false },
            text:
              '<h2 class="ql-align-center">SULTRY &amp; SMART</h2><h5 class="ql-align-center">HOT SPRING LOOKS</h5>',
            type: "TextView",
            isLink: false,
            parent: "Content",
            lineHeight: "120%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "20px 0px 0px 0px"
          }
        },
        style: {},
        parent: { id: "1k365", idx: 0 },
        childOf: "Content",
        children: []
      },
      "95gb4": {
        id: "95gb4",
        type: "Row2",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(212, 228, 224, 1)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  width: { type: "%", contentWidth: 100 },
                  column: 2,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "10px",
                  alignment: { vertical: "center", horizontal: "center" },
                  className: "col-xs-12 col-lg-6 col-md-6",
                  backgroundColor: "rgba(163, 199, 189, 1)",
                  backgroundImage: {
                    url: "",
                    mobile: { width: 0, height: 0 },
                    desktop: { width: 0, height: 0 },
                    urlMobile: ""
                  },
                  isBackgroundImage: false,
                  backgroundColorParent: "rgba(163, 199, 189, 1)"
                }
              },
              childOf: "Row",
              children: []
            },
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 2,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  className: "col-xs-12 col-lg-6 col-md-6",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: {
                    url: "",
                    mobile: { width: 0, height: 0 },
                    desktop: { width: 0, height: 0 },
                    urlMobile: ""
                  },
                  isBackgroundImage: false
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 1 },
        childOf: "Body",
        children: ["38lau", "bpouu"]
      },
      ap843: {
        id: "ap843",
        type: "FlatButtonView",
        props: {
          values: {
            href: {
              url: "",
              target: "_blank",
              collection: 25,
              isCollection: true
            },
            icon: "",
            text: "Shop Men",
            type: "FlatButtonView",
            border: { size: 0, type: "solid", color: "#e61919" },
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "center",
            buttonColors: {
              color: "rgba(255, 255, 255, 1)",
              hoverColor: "rgba(155, 155, 155, 0.2)",
              rippleColor: "rgba(255, 153, 0, 0.1)",
              backgroundColor: "rgba(230, 25, 25, 0)"
            },
            labelPosition: "before",
            containerPadding: "20px"
          }
        },
        style: {},
        parent: { id: "38lau", idx: 2 },
        childOf: "Content",
        children: []
      },
      bpouu: {
        id: "bpouu",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 2,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12 col-lg-6 col-md-6",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: {
              url: "",
              mobile: { width: 0, height: 0 },
              desktop: { width: 0, height: 0 },
              urlMobile: ""
            },
            isBackgroundImage: false
          }
        },
        parent: { id: "95gb4", idx: 1 },
        childOf: "Row",
        children: ["5209c"]
      },
      cr1r7: {
        id: "cr1r7",
        type: "TextView",
        props: {
          values: {
            href: { url: "", target: "", collection: 0, isCollection: false },
            text:
              '<h2 class="ql-align-center"><span style="color: rgb(253, 253, 253);">ELEGANT &amp; SLICK</span></h2><h5 class="ql-align-center"><span style="color: rgb(253, 253, 253);">GET READY FOR SUMMER</span></h5><p><br></p>',
            type: "TextView",
            isLink: false,
            parent: "Content",
            lineHeight: "120%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "20px 0px 0px 0px"
          }
        },
        style: {},
        parent: { id: "38lau", idx: 0 },
        childOf: "Content",
        children: []
      },
      f5n52: {
        id: "f5n52",
        type: "Row2",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(245, 243, 242, 1)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  column: 2,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  className: "col-xs-12 col-lg-6 col-md-6",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: {
                    url: "",
                    mobile: { width: 0, height: 0 },
                    desktop: { width: 0, height: 0 },
                    urlMobile: ""
                  },
                  isBackgroundImage: false
                }
              },
              childOf: "Row",
              children: []
            },
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  width: { type: "%", contentWidth: 100 },
                  column: 2,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "10px",
                  alignment: { vertical: "center", horizontal: "center" },
                  className: "col-xs-12 col-lg-6 col-md-6",
                  backgroundColor: "rgba(254, 233, 228, 1)",
                  backgroundImage: {
                    url: "",
                    mobile: { width: 0, height: 0 },
                    desktop: { width: 0, height: 0 },
                    urlMobile: ""
                  },
                  isBackgroundImage: false,
                  backgroundColorParent: "rgba(254, 233, 228, 1)"
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 0 },
        childOf: "Body",
        children: ["2ac6m", "1k365"]
      }
    }
  },
  {
    id: 6,
    title: "Fashion3",
    thumbnail:
      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-F78.png",
    content: {
      root: {
        id: "root",
        type: "Body",
        props: {
          values: {
            width: { type: "px", contentWidth: 900 },
            contentWidth: "900px",
            backgroundColor: "#ececec",
            backgroundImage: { url: "" }
          }
        },
        children: ["8932e", "tfs3"]
      },
      tfs3: {
        id: "tfs3",
        type: "Row4",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(121, 105, 143, 0)",
            backgroundImage: {
              url: "",
              mobile: { width: 0, height: 0 },
              desktop: { width: 0, height: 0 },
              urlMobile: ""
            },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  width: { type: "%", contentWidth: 100 },
                  column: 1,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  alignment: { vertical: "center", horizontal: "center" },
                  className: "col-xs-12 col-md-3 col-lg-3",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: {
                    url: "",
                    mobile: { width: 0, height: 0 },
                    desktop: { width: 0, height: 0 },
                    urlMobile: ""
                  },
                  isBackgroundImage: false
                }
              },
              childOf: "Row",
              children: []
            },
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  width: { type: "%", contentWidth: 100 },
                  column: 3,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  alignment: { vertical: "center", horizontal: "center" },
                  className: "col-xs-12 col-md-9 col-lg-9",
                  backgroundColor: "rgba(121, 105, 143, 1)",
                  backgroundImage: {
                    url: "",
                    mobile: { width: 0, height: 0 },
                    desktop: { width: 0, height: 0 },
                    urlMobile: ""
                  },
                  isBackgroundImage: false,
                  backgroundColorParent: "rgba(121, 105, 143, 1)"
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 1 },
        childOf: "Body",
        children: ["3v1gk", "corl9"]
      },
      "1erjn": {
        id: "1erjn",
        type: "FlatButtonView",
        props: {
          values: {
            href: {
              url: "https://ola.id",
              target: "_blank",
              collection: 0,
              isCollection: false
            },
            icon: "",
            text: "Read more >",
            type: "FlatButtonView",
            border: { size: 0, type: "solid", color: "#e61919" },
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "center",
            buttonColors: {
              color: "#FFF",
              hoverColor: "rgba(170, 156, 189, 1)",
              rippleColor: "rgba(255, 153, 0, 0)",
              backgroundColor: "rgba(230, 25, 25, 0)"
            },
            labelPosition: "before",
            containerPadding: "10px"
          }
        },
        style: {},
        parent: { id: "corl9", idx: 3 },
        childOf: "Content",
        children: []
      },
      "3v1gk": {
        id: "3v1gk",
        type: "Content",
        props: {
          values: {
            type: "Content",
            width: { type: "%", contentWidth: 100 },
            column: 1,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            alignment: { vertical: "center", horizontal: "center" },
            className: "col-xs-12 col-md-3 col-lg-3",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: {
              url: "",
              mobile: { width: 0, height: 0 },
              desktop: { width: 0, height: 0 },
              urlMobile: ""
            },
            isBackgroundImage: false
          }
        },
        parent: { id: "tfs3", idx: 0 },
        childOf: "Row",
        children: ["839bf"]
      },
      "4o1io": {
        id: "4o1io",
        type: "TextView",
        props: {
          values: {
            href: { url: "", target: "", collection: 0, isCollection: false },
            text:
              '<h1 class="ql-align-center"><span class="ql-font-GreatVibes">Natural, gorgeous</span></h1><h1 class="ql-align-center"><span class="ql-font-GreatVibes">hair&nbsp;for&nbsp;everyday</span></h1>',
            type: "TextView",
            isLink: false,
            parent: "Content",
            lineHeight: "180%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "10px"
          }
        },
        style: {},
        parent: { id: "9kmoe", idx: 0 },
        childOf: "Content",
        children: []
      },
      "572bg": {
        id: "572bg",
        type: "FlatButtonView",
        props: {
          values: {
            href: { url: "", target: "", collection: 0, isCollection: false },
            icon: "",
            text: "Shop now",
            type: "FlatButtonView",
            border: { size: 0, type: "solid", color: "#e61919" },
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "center",
            buttonColors: {
              color: "#FFF",
              hoverColor: "rgba(155, 155, 155, 0.4)",
              rippleColor: "rgba(255, 153, 0, 0)",
              backgroundColor: "rgba(122, 106, 143, 1)"
            },
            labelPosition: "before",
            containerPadding: "10px"
          }
        },
        style: {},
        parent: { id: "9kmoe", idx: 1 },
        childOf: "Content",
        children: []
      },
      "839bf": {
        id: "839bf",
        type: "CarouselView",
        props: {
          values: {
            auto: false,
            type: "CarouselView",
            parent: "Content",
            altText: "Carousel",
            imageUrl: {
              url: [
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/image-carousel-desktop-2ZG.jpeg",
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/image-carousel-desktop-OA8.jpeg",
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/image-carousel-desktop-8AO.jpeg",
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/image-carousel-desktop-KWT.jpeg"
              ],
              urlMobile: []
            },
            interval: 5,
            direaction: "incremental"
          }
        },
        style: {},
        parent: { id: "3v1gk", idx: 0 },
        childOf: "Content",
        children: []
      },
      "8932e": {
        id: "8932e",
        type: "Row1",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.8,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: {
              url:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-desktop-KXD.jpeg",
              desktop: { width: 1200, height: 655 },
              urlMobile: ""
            },
            isBackgroundImage: true
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  width: { type: "px", contentWidth: 300 },
                  column: 1,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.8,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "10px",
                  alignment: { vertical: "center", horizontal: "flex-start" },
                  className: "col-xs-12",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: {
                    url: "",
                    mobile: { width: 0, height: 0 },
                    desktop: { width: 1200, height: 655 },
                    urlMobile: ""
                  },
                  isBackgroundImage: true
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 0 },
        childOf: "Body",
        children: ["9kmoe"]
      },
      "9kmoe": {
        id: "9kmoe",
        type: "Content",
        props: {
          values: {
            type: "Content",
            width: { type: "%", contentWidth: 100 },
            column: 1,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            alignment: { vertical: "center", horizontal: "center" },
            className: "col-xs-12",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: {
              url: "",
              mobile: { width: 0, height: 0 },
              desktop: { width: 0, height: 0 },
              urlMobile: ""
            },
            isBackgroundImage: false
          }
        },
        parent: { id: "8932e", idx: 0 },
        childOf: "Row",
        children: ["4o1io", "572bg"]
      },
      a9p03: {
        id: "a9p03",
        type: "TextView",
        props: {
          values: {
            href: { url: "", target: "", collection: 0, isCollection: false },
            text:
              '<h1 class="ql-align-center"><em style="color: rgb(255, 255, 255);">Why Clipped?</em></h1>',
            type: "TextView",
            isLink: false,
            parent: "Content",
            lineHeight: "120%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "20px 10px 10px 10px"
          }
        },
        style: {},
        parent: { id: "corl9", idx: 0 },
        childOf: "Content",
        children: []
      },
      aj36s: {
        id: "aj36s",
        type: "DividerView",
        props: {
          values: {
            line: "solid",
            size: "2px",
            type: "DividerView",
            width: "10%",
            parent: "Content",
            lineColor: "rgba(255,255,255,1)",
            alignValue: "center",
            containerPadding: "20px"
          }
        },
        style: {},
        parent: { id: "corl9", idx: 1 },
        childOf: "Content",
        children: []
      },
      corl9: {
        id: "corl9",
        type: "Content",
        props: {
          values: {
            type: "Content",
            width: { type: "%", contentWidth: 100 },
            column: 3,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            alignment: { vertical: "center", horizontal: "center" },
            className: "col-xs-12 col-md-9 col-lg-9",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: {
              url: "",
              mobile: { width: 0, height: 0 },
              desktop: { width: 0, height: 0 },
              urlMobile: ""
            },
            isBackgroundImage: false
          }
        },
        parent: { id: "tfs3", idx: 1 },
        childOf: "Row",
        children: ["a9p03", "aj36s", "du0tn", "1erjn"]
      },
      du0tn: {
        id: "du0tn",
        type: "TextView",
        props: {
          values: {
            href: { url: "", target: "", collection: 0, isCollection: false },
            text:
              '<p class="ql-align-center"><span style="color: rgb(224, 213, 240);">I\'m a paragraph. Click here to add your own text and edit me. It’s easy.</span></p><p class="ql-align-center"><span style="color: rgb(224, 213, 240);">Just click “Edit Text” or double click me to add your own content and make changes to the font. Feel free to drag and drop me anywhere you like on your page. I’m a great place for you to tell a story and let your users know a little more about you.</span></p><p><br></p>',
            type: "TextView",
            isLink: false,
            parent: "Content",
            lineHeight: "140%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "10px"
          }
        },
        style: {},
        parent: { id: "corl9", idx: 2 },
        childOf: "Content",
        children: []
      }
    }
  },
  {
    id: 7,
    title: "Camera",
    thumbnail:
      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-Q4L.png",
    content: {
      root: {
        id: "root",
        type: "Body",
        props: {
          values: {
            width: { type: "px", contentWidth: 960 },
            contentWidth: "960px",
            backgroundColor: "rgba(255, 255, 255, 1)",
            backgroundImage: { url: "" }
          }
        },
        children: ["9ihs1", "2f2la"]
      },
      "2f2la": {
        id: "2f2la",
        type: "Row2",
        props: {
          values: {
            type: "Row",
            align: "center",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: { url: "", urlMobile: "" },
            isBackgroundImage: false
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  width: { type: "%", contentWidth: 100 },
                  column: 2,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.8,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  alignment: { vertical: "center", horizontal: "center" },
                  className: "col-xs-12 col-lg-6 col-md-6",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: {
                    url:
                      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-desktop-ZWT.jpeg",
                    mobile: { width: 0, height: 0 },
                    desktop: { width: 282, height: 188 },
                    urlMobile: ""
                  },
                  isBackgroundImage: true
                }
              },
              childOf: "Row",
              children: []
            },
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  width: { type: "%", contentWidth: 100 },
                  column: 2,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.8,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "0px",
                  alignment: { vertical: "center", horizontal: "center" },
                  className: "col-xs-12 col-lg-6 col-md-6",
                  backgroundColor: "rgba(255,255,255,0)",
                  backgroundImage: {
                    url:
                      "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-desktop-215.png",
                    mobile: { width: 0, height: 0 },
                    desktop: { width: 482, height: 188 },
                    urlMobile: ""
                  },
                  isBackgroundImage: true
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 1 },
        childOf: "Body",
        children: ["ej14j", "4pe9q"]
      },
      "4pe9q": {
        id: "4pe9q",
        type: "Content",
        props: {
          values: {
            type: "Content",
            width: { type: "%", contentWidth: 100 },
            column: 2,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            alignment: { vertical: "center", horizontal: "center" },
            className: "col-xs-12 col-lg-6 col-md-6",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: {
              url: "",
              mobile: { width: 0, height: 0 },
              desktop: { width: 0, height: 0 },
              urlMobile: ""
            },
            isBackgroundImage: false
          }
        },
        parent: { id: "2f2la", idx: 1 },
        childOf: "Row",
        children: ["cj331"]
      },
      "95tns": {
        id: "95tns",
        type: "TextView",
        props: {
          values: {
            href: { url: "", target: "", collection: 0, isCollection: false },
            text:
              '<h1>PRICE&nbsp;</h1><h1>DROP!</h1><p><br></p><p><span class="ql-size-large"><span class="ql-cursor">﻿</span>Up to&nbsp;15% Off All </span></p><p><span class="ql-size-large">﻿Our Products!</span></p>',
            type: "TextView",
            isLink: false,
            parent: "Content",
            lineHeight: "200%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255, 255, 255, 0)",
            containerPadding: "10px"
          }
        },
        style: {},
        parent: { id: "alr7h", idx: 0 },
        childOf: "Content",
        children: []
      },
      "97s6d": {
        id: "97s6d",
        type: "TextView",
        props: {
          values: {
            href: { url: "", target: "", collection: 0, isCollection: false },
            text:
              '<h1 class="ql-align-center"><span style="color: rgb(255, 255, 255);">2 YEARS WARRANTY</span></h1><h1 class="ql-align-center"><span style="color: rgb(255, 255, 255);">ON OUR ENTIRE </span></h1><h1 class="ql-align-center"><span style="color: rgb(255, 255, 255);">﻿LENSES SELECTION</span></h1>',
            type: "TextView",
            isLink: false,
            parent: "Content",
            lineHeight: "200%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "ej14j", idx: 0 },
        childOf: "Content",
        children: []
      },
      "9ihs1": {
        id: "9ihs1",
        type: "Row1",
        props: {
          values: {
            type: "Row",
            align: "flex-end",
            width: { type: "%", contentWidth: 100 },
            parent: "Body",
            bgProps: {
              size: "cover",
              ratio: 1.8,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: {
              url:
                "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ease-image-desktop-G13.jpeg",
              desktop: { width: 2800, height: 1715 },
              urlMobile: ""
            },
            isBackgroundImage: true
          },
          content: [
            {
              type: "Content",
              props: {
                values: {
                  type: "Content",
                  width: { type: "px", contentWidth: 320 },
                  column: 1,
                  parent: "Row",
                  bgProps: {
                    size: "cover",
                    ratio: 1.2,
                    repeat: "no-repeat",
                    position: "center"
                  },
                  padding: "10px",
                  alignment: { vertical: "center", horizontal: "flex-start" },
                  className: "col-xs-12",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                  backgroundImage: {
                    url: "",
                    mobile: { width: 0, height: 0 },
                    desktop: { width: 0, height: 0 },
                    urlMobile: ""
                  },
                  isBackgroundImage: false
                }
              },
              childOf: "Row",
              children: []
            }
          ]
        },
        style: {},
        parent: { id: "root", idx: 0 },
        childOf: "Body",
        children: ["alr7h"]
      },
      alr7h: {
        id: "alr7h",
        type: "Content",
        props: {
          values: {
            type: "Content",
            column: 1,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            className: "col-xs-12",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: {
              url: "",
              mobile: { width: 0, height: 0 },
              desktop: { width: 0, height: 0 },
              urlMobile: ""
            },
            isBackgroundImage: false
          }
        },
        parent: { id: "9ihs1", idx: 0 },
        childOf: "Row",
        children: ["95tns", "bsd0j"]
      },
      bsd0j: {
        id: "bsd0j",
        type: "FlatButtonView",
        props: {
          values: {
            href: { url: "", target: "", collection: 0, isCollection: false },
            icon: "",
            text: "Show Now",
            type: "FlatButtonView",
            border: { size: 0, type: "solid", color: "#e61919" },
            parent: "Content",
            fullWidth: false,
            typeButton: "flat",
            buttonAlign: "flex-start",
            buttonColors: {
              color: "#FFF",
              hoverColor: "#42d696",
              rippleColor: "#FF9900",
              backgroundColor: "rgba(245, 166, 35, 1)"
            },
            labelPosition: "before",
            containerPadding: "10px"
          }
        },
        style: {},
        parent: { id: "alr7h", idx: 1 },
        childOf: "Content",
        children: []
      },
      cj331: {
        id: "cj331",
        type: "TextView",
        props: {
          values: {
            href: { url: "", target: "", collection: 0, isCollection: false },
            text:
              '<h1 class="ql-align-center"><span style="color: rgb(255, 255, 255);">IN STOCK NOW !</span></h1>',
            type: "TextView",
            isLink: false,
            parent: "Content",
            lineHeight: "120%",
            letterSpacing: "1px",
            backgroundColor: "rgba(255,255,255,0)",
            containerPadding: "0px"
          }
        },
        style: {},
        parent: { id: "4pe9q", idx: 0 },
        childOf: "Content",
        children: []
      },
      ej14j: {
        id: "ej14j",
        type: "Content",
        props: {
          values: {
            type: "Content",
            width: { type: "%", contentWidth: 100 },
            column: 2,
            parent: "Row",
            bgProps: {
              size: "cover",
              ratio: 1.2,
              repeat: "no-repeat",
              position: "center"
            },
            padding: "0px",
            alignment: { vertical: "center", horizontal: "center" },
            className: "col-xs-12 col-lg-6 col-md-6",
            backgroundColor: "rgba(255,255,255,0)",
            backgroundImage: {
              url: "",
              mobile: { width: 0, height: 0 },
              desktop: { width: 0, height: 0 },
              urlMobile: ""
            },
            isBackgroundImage: false
          }
        },
        parent: { id: "2f2la", idx: 0 },
        childOf: "Row",
        children: ["97s6d"]
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/editor/layout/dataTemplate.js